export default __webpack_public_path__ + "static/banner-why-millennials-are-becoming-the-most-financial-savvy-generation-c98d799d21e9189bd1663d1d0c548718.jpg";